/* eslint-disable */
const mockCompaniesList: any[] = [
  {
    data: {
      country: 'CZ',
      name: 'Západočeská univerzita v Plzni',
      taxNumber: null,
      vatNumber: 'CZ49777513',
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Plzeňský kraj',
          district: 'Plzeň-město',
          ids: {
            internal: '2c3318ce-b1f1-4f78-b601-5ad977c645c9',
            external: '24557196',
          },
          street: 'Univerzitní',
          number: {
            type: 'č.p.',
            part1: '2732',
            part1Number: '2732',
            part1Letter: null,
            part2: '8',
            part2Number: '8',
            part2Letter: null,
            full: '2732/8',
          },
          streetWithNumber: 'Univerzitní 2732/8',
          city: 'Plzeň',
          zip: '30100',
          full: 'Univerzitní 2732/8, 30100 Plzeň',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Univerzitní',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '2732/8',
          },
          streetWithNumber: 'Univerzitní 2732/8',
          city: 'Plzeň',
          zip: '30100',
          full: 'Univerzitní 2732/8, Jižní Předměstí, 30100 Plzeň',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '601',
        name: 'Vysoká škola (veřejná, státní)',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '6820',
          name: 'Pronájem a správa vlastních nebo pronajatých nemovitostí',
        },
        {
          code: '721',
          name: 'Výzkum a vývoj v oblasti přírodních a technických věd',
        },
        {
          code: '773',
          name: 'Pronájem a leasing ostatních strojů, zařízení a výrobků',
        },
        {
          code: '85420',
          name: 'Terciární vzdělávání',
        },
      ],
      registrations: [
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '138',
              name: 'Územní pracoviště v Plzni',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '13110',
        name: 'Ústřední vládní instituce (kromě fondů sociálního zabezpečení)',
      },
      dates: {
        created: '1995-01-01',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Poradenská, školící a rekvalifikační činnost v oblasti strojírenství, elektrotechniky, software/hartver',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Realitní kancelář, včetně pronájmu bytových a nebytových prostor',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Kompletace strojních, elektro a elektronických součástek a modulů',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Směnárenská činnost',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Konstrukční práce ve strojírenství',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Koupě zboží za účelem jeho dalšího prodeje a prodej',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Školící a konzultační činnost v oblasti ekonomie',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Provádění vědeckovýzkumných výpočtů a expertíz v oblasti elektrotechniky, strojírenství, přírodních věd',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkování obchodu a služeb',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Poradenská, konzultační a školící činnost v oblasti přírodních věd',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Investorská a inženýrská činnost',
          valid: {
            from: '1993-01-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Poskytování software',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Automatizované zpracování dat',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Zámečnictví',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Stavba strojů s mechanickým pohonem',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Provozování veřejných tělovýchovných škol, pořádání kurzů pro cvičitele, trenéry a rozhodčí, pořádání tělovýchovných kurzů a činnost sportovních instruktorů',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Kovoobrábění',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Vodoinstalatérství',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Provozování tělovýchovných zařízení a zařízení sloužících regeneraci a rekondici',
          valid: {
            from: '1993-02-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Výroba, montáž a opravy výrobků a zařízení spotřební elektroniky',
          valid: {
            from: '1993-02-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Montáž a opravy kancelářské a reprodukční elektroniky',
          valid: {
            from: '1993-02-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Montáž a opravy měřící regulační techniky',
          valid: {
            from: '1993-02-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Výroba, instalace a opravy elektrických strojů a přístrojů',
          valid: {
            from: '1993-02-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Výuka ruského jazyka',
          valid: {
            from: '1993-03-24',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Veřejné ubytovací služby včetně poskytování jiných než základních služeb',
          valid: {
            from: '1994-11-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Zámečnictví, nástrojářství',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Provozování veřejných tělovýchovných škol, pořádání kursů pro cvičitele, trenéry a rozhodčí, pořádání tělovýchovných kursů a činnost sportovních instruktorů',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Provozování tělovýchovných a sportovních zařízení a organizování sportovní činnosti',
            'Vydavatelské činnosti, polygrafická výroba, knihařské a kopírovací práce',
            'Poskytování software, poradenství v oblasti informačních technologií, zpracování dat, hostingové a související činnosti a webové portály',
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Výroba strojů a zařízení',
            'Příprava a vypracování technických návrhů, grafické a kresličské práce',
            'Výzkum a vývoj v oblasti přírodních a technických věd nebo společenských věd',
            'Mimoškolní výchova a vzdělávání, pořádání kurzů, školení, včetně lektorské činnosti',
            'Velkoobchod a maloobchod',
            'Výroba, rozmnožování, distribuce, prodej, pronájem zvukových a zvukově-obrazových záznamů a výroba nenahraných nosičů údajů a záznamů',
            'Povrchové úpravy a svařování kovů a dalších materiálů',
            'Ubytovací služby',
            'Překladatelská a tlumočnická činnost',
            'Testování, měření, analýzy a kontroly',
            'Výroba, obchod a služby jinde nezařazené',
            'Provozování kulturních, kulturně-vzdělávacích a zábavních zařízení, pořádání kulturních produkcí, zábav, výstav, veletrhů, přehlídek, prodejních a obdobných akcí',
            'Reklamní činnost, marketing, mediální zastoupení',
            'Přípravné a dokončovací stavební práce, specializované stavební činnosti',
            'Nákup, prodej, správa a údržba nemovitostí',
            'Pronájem a půjčování věcí movitých',
          ],
        },
        {
          type: 'živnost volná',
          name: 'Výroba strojů a zařízení pro využití mechanické energie',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Obráběčství',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Poskytování software a poradenství v oblasti hardware a software',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Provozování tělovýchovných zařízení a zařízení sloužících regeneraci a rekondici',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Poskytování tělovýchovných a sportovních služeb v oblasti  zumby, aerobicu, pilates a powerjógy',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Daniel Sys',
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Vodoinstalatérství',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zpracování dat, služby databank a správa sítí',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Provozování  tělovýchovných  zařízení a zařízení sloužících regeneraci a rekondici',
          valid: {
            from: '1995-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Pořádání odborných kursů, školení a jiných vzdělávacích akcí, včetně lektorské činnosti',
          valid: {
            from: '1995-04-12',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výzkum a vývoj v oblasti přírodních, technických a společenských věd',
          valid: {
            from: '1995-04-12',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Činnost podnikatelských, finančních, organizačních a ekonomických poradců',
          valid: {
            from: '1995-04-12',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Činnost technických poradců v oblasti strojírenství, hutnictví a energetiky',
          valid: {
            from: '1995-04-12',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Veřejné ubytovací služby včetně poskytování jiných než základních služeb',
          valid: {
            from: '1995-04-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Příprava a vypracování technických návrhů',
          valid: {
            from: '1995-04-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Ubytovací služby',
          valid: {
            from: '1995-04-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Kompletace strojních, elektro a elektronických součástek a modulů',
          valid: {
            from: '1995-04-26',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Silniční motorová doprava - nákladní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 3,5 tuny, jsou-li určeny k přepravě zvířat nebo věcí, - nákladní vnitrostátní provozovaná vozidly o největší povolené hmotnosti nad 3,5 tuny, - vnitrostátní příležitostná osobní, - mezinárodní příležitostná osobní',
          valid: {
            from: '1995-05-24',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Silniční motorová doprava osobní',
          valid: {
            from: '1995-05-24',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Silniční motorová doprava nákladní - vnitrostátní',
          valid: {
            from: '1995-06-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Montáž, oprava, údržba vyhrazených elektrických zařízení',
          valid: {
            from: '1995-06-07',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Kopírovací práce',
          valid: {
            from: '1995-07-24',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Specializovaný maloobchod',
          valid: {
            from: '1999-02-15',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Hostinská činnost',
          valid: {
            from: '1999-05-05',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Jitka Hurtová',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Veřejné ubytovací služby',
          valid: {
            from: '1999-05-31',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Provozování solárií',
          valid: {
            from: '1999-06-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Provoz solária',
          valid: {
            from: '1999-06-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Pořádání tělovýchovných kurzů - plavání pro veřejnost',
          valid: {
            from: '1999-06-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Masérské služby',
          valid: {
            from: '1999-06-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Masérské, rekondiční a regenerační služby',
          valid: {
            from: '1999-06-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba a prodej audiovizuálních záznamů a ucelených autorských pořadů převážně výukových',
          valid: {
            from: '1999-07-07',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Maloobchodní prodej a pronájem zvukových a zvukově obrazových záznamů a jejich nenahraných nosičů',
          valid: {
            from: '1999-07-07',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, rozmnožování a nahrávání zvukových a zvukově obrazových záznamů',
          valid: {
            from: '1999-07-07',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Povrchové úpravy a svařování kovů',
          valid: {
            from: '1999-09-06',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Výroba, instalace, opravy elektrických strojů a přístrojů, elektronických a telekomunikačních zařízení',
          valid: {
            from: '2005-03-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Ing. Aleš Hamáček Ph.D.',
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Prodej kvasného lihu, konzumního lihu a lihovin',
          valid: {
            from: '2014-04-02',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Vývoj, opravy a úpravy zbraní',
          valid: {
            from: '2015-01-29',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Masérské, rekondiční a regenerační služby',
          valid: {
            from: '2016-03-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Mgr. Rita Firýtová',
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '4811530257/0100',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      country: 'CZ',
      name: 'Západočeské konzumní družstvo Sušice',
      taxNumber: null,
      vatNumber: 'CZ00031968',
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Plzeňský kraj',
          district: 'Klatovy',
          ids: {
            internal: 'd73a1f6f-d3f7-4afb-9f2d-276802136e35',
            external: '7004486',
          },
          street: 'náměstí Svobody',
          number: {
            type: 'č.p.',
            part1: '135',
            part1Number: '135',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '135',
          },
          streetWithNumber: 'náměstí Svobody 135',
          city: 'Sušice',
          zip: '34201',
          full: 'náměstí Svobody 135, 34201 Sušice',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'náměstí Svobody',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '135',
          },
          streetWithNumber: 'náměstí Svobody 135',
          city: 'Sušice',
          zip: '34201',
          full: 'náměstí Svobody 135, Sušice I, 34201 Sušice',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '205',
        name: 'Družstvo',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '107',
          name: 'Výroba pekařských, cukrářských a jiných moučných výrobků',
          isPrimary: null,
        },
        {
          code: '47110',
          name: 'Maloobchod s převahou potravin, nápojů a tabákových výrobků v nespecializovaných prodejnách',
          isPrimary: null,
        },
        {
          code: '49410',
          name: 'Silniční nákladní doprava',
          isPrimary: null,
        },
        {
          code: '56100',
          name: 'Stravování v restauracích, u stánků a v mobilních zařízeních',
          isPrimary: null,
        },
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '47250',
          name: 'Maloobchod s nápoji',
        },
        {
          code: '10110',
          name: 'Zpracování a konzervování masa, kromě drůbežího',
        },
        {
          code: '351',
          name: 'Výroba, přenos a rozvod elektřiny',
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSPL',
              name: 'Krajský soud v Plzni',
              detail: null,
            },
            reference: 'DrXXVI 218',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '133',
              name: 'Územní pracoviště v Klatovech',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '1956-10-18',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost řemeslná',
          name: 'Pekařství, cukrářství',
          valid: {
            from: '1992-08-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Ing. Roman Bruzl',
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Prodej drogistického zboží',
          valid: {
            from: '1992-08-18',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Koupě zboží za účelem jeho dalšího prodeje a prodej v režimu živnosti volné',
          valid: {
            from: '1992-08-18',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '1992-08-18',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Velkoobchod a maloobchod',
            'Výroba, obchod a služby jinde nezařazené',
            'Skladování, balení zboží, manipulace s nákladem a technické činnosti v dopravě',
            'Zprostředkování obchodu a služeb',
            'Výroba potravinářských a škrobárenských výrobků',
            'Vydavatelské činnosti, polygrafická výroba, knihařské a kopírovací práce',
            'Ubytovací služby',
          ],
        },
        {
          type: 'živnost řemeslná',
          name: 'Řeznictví a uzenářství',
          valid: {
            from: '1992-08-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Ing. Roman Bruzl',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Specializovaný maloobchod',
          valid: {
            from: '1992-09-15',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Silniční motorová doprava - nákladní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti přesahující 3,5 tuny určenými k přepravě zvířat nebo věcí, - nákladní vnitrostátní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 3,5 tuny určenými k přepravě zvířat nebo věcí a nákladní mezinárodní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 2,5 tuny určenými k přepravě zvířat nebo věcí',
          valid: {
            from: '1992-09-29',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Petr Koželuh',
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Směnárenská činnost',
          valid: {
            from: '1992-10-01',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Ubytovací služby v ubytovacím zařízení - hotel **',
          valid: {
            from: '1992-10-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Hostinská činnost',
          valid: {
            from: '1992-10-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Hostinská činnost',
          valid: {
            from: '1992-10-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Ing. Roman Bruzl',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Ubytovací služby v ubytovacích zařízeních v režimu živnosti volné',
          valid: {
            from: '1993-02-10',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Pekařství',
          valid: {
            from: '1993-04-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Nákup, prodej a skladování zkapalněných uhlovodíkových plynů  do  40  kg  náplně  tlakové nádoby a do 1000 kg skladovací kapacity včetně',
          valid: {
            from: '2003-03-31',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba potravinářských výrobků',
          valid: {
            from: '2007-03-05',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Prodej kvasného lihu, konzumního lihu a lihovin',
          valid: {
            from: '2013-11-11',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '119351/0100',
          },
          {
            number: '150086954/0300',
          },
          {
            number: '230801110/0300',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      country: 'CZ',
      name: 'ZAPA beton a.s.',
      taxNumber: null,
      vatNumber: 'CZ25137026',
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Hlavní město Praha',
          district: 'území Hlavního města Prahy',
          ids: {
            internal: 'e543a666-654a-43a8-84aa-43b7832b6839',
            external: '25971875',
          },
          street: 'Michle',
          number: {
            type: 'č.ev.',
            part1: '417',
            part1Number: '417',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '417',
          },
          streetWithNumber: 'Michle č.ev. 417',
          city: 'Praha 4',
          zip: '14100',
          full: 'Michle č.ev. 417, 14100 Praha 4',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Michle',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '417',
          },
          streetWithNumber: 'Michle 417',
          city: 'Praha',
          zip: '14100',
          full: 'Michle č.ev. 417, 14100 Praha 4',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '121',
        name: 'Akciová společnost',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '081',
          name: 'Dobývání kamene, písků a jílů',
          isPrimary: null,
        },
        {
          code: '74902',
          name: 'Poradenství v oblasti požární ochrany',
          isPrimary: null,
        },
        {
          code: '52290',
          name: 'Ostatní vedlejší činnosti v dopravě',
          isPrimary: null,
        },
        {
          code: '47',
          name: 'Maloobchod, kromě motorových vozidel',
          isPrimary: null,
        },
        {
          code: '74901',
          name: 'Poradenství v oblasti bezpečnosti a ochrany zdraví při práci',
          isPrimary: null,
        },
        {
          code: '38110',
          name: 'Shromažďování a sběr odpadů, kromě nebezpečných',
          isPrimary: null,
        },
        {
          code: '70220',
          name: 'Ostatní poradenství v oblasti podnikání a řízení',
          isPrimary: null,
        },
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '46',
          name: 'Velkoobchod, kromě motorových vozidel',
          isPrimary: null,
        },
        {
          code: '7120',
          name: 'Technické zkoušky a analýzy',
          isPrimary: null,
        },
        {
          code: '38120',
          name: 'Shromažďování a sběr nebezpečných odpadů',
          isPrimary: null,
        },
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '236',
          name: 'Výroba betonových, cementových a sádrových výrobků',
          isPrimary: null,
        },
        {
          code: '45200',
          name: 'Opravy a údržba motorových vozidel, kromě motocyklů',
          isPrimary: null,
        },
        {
          code: '49410',
          name: 'Silniční nákladní doprava',
          isPrimary: null,
        },
        {
          code: '6820',
          name: 'Pronájem a správa vlastních nebo pronajatých nemovitostí',
          isPrimary: null,
        },
        {
          code: '7219',
          name: 'Ostatní výzkum a vývoj v oblasti přírodních a technických věd',
          isPrimary: null,
        },
        {
          code: '772',
          name: 'Pronájem a leasing výrobků pro osobní potřebu a převážně pro domácnost',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'MSPH',
              name: 'Městský soud v Praze',
              detail: null,
            },
            reference: 'B 4785',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '013',
              name: 'Specializovaný finanční úřad',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11003',
        name: 'Nefinanční podniky pod zahraniční kontrolou',
      },
      dates: {
        created: '1997-06-16',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Pronájem motorových vozidel',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkování dopravy cementových materiálů a jejich uložení',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Koupě zboží za účelem jeho dalšího prodeje a prodej (vyjma zboží uvedeného v příloze 1, 2 a 3 cit.zákona)',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba cementového zboží',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkovatelská činnost v oblasti obchodu a služeb',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Opravy silničních vozidel',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Jozef Máťaš',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Pronájem nemovitého majetku s poskytováním jiných než základních služeb spojených s pronájmem',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Pronájem movitého majetku',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Pronájem průmyslového zboží',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '1997-06-16',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Výroba stavebních hmot, porcelánových, keramických a sádrových výrobků',
            'Velkoobchod a maloobchod',
            'Nakládání s odpady (vyjma nebezpečných)',
            'Zprostředkování obchodu a služeb',
            'Zasilatelství a zastupování v celním řízení',
            'Pronájem a půjčování věcí movitých',
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Výzkum a vývoj v oblasti přírodních a technických věd nebo společenských věd',
            'Výroba, obchod a služby jinde nezařazené',
          ],
        },
        {
          type: 'živnost koncesovaná',
          name: 'Silniční motorová doprava - nákladní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti přesahující 3,5 tuny určenými k přepravě zvířat nebo věcí, - nákladní mezinárodní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti přesahující 2,5 tuny a nepřesahující 3,5 tuny určenými k přepravě zvířat nebo věcí, - nákladní vnitrostátní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 3,5 tuny určenými k přepravě zvířat nebo věcí a nákladní mezinárodní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 2,5 tuny určenými k přepravě zvířat nebo věcí',
          valid: {
            from: '1997-11-24',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Jozef Máťaš',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba a uložení betonových směsí',
          valid: {
            from: '1998-07-01',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Podnikání v oblasti nakládání s odpady (vyjma nebezpečných)',
          valid: {
            from: '1999-07-09',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Podnikání v oblasti nakládání s nebezpečnými odpady',
          valid: {
            from: '1999-07-26',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Ing. Viktor Slezák',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výzkum a vývoj v oblasti stavebnictví',
          valid: {
            from: '2004-09-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Činnost podnikatelských, finančních, organizačních a ekonomických poradců',
          valid: {
            from: '2004-09-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Činnost účetních poradců, vedení účetnictví, vedení daňové evidence',
          valid: {
            from: '2004-09-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Provozování čerpacích stanic s pohonnými hmotami',
          valid: {
            from: '2007-03-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba jinde nezařazená v oblasti kameniva',
          valid: {
            from: '2007-03-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Technicko-organizační činnost v oblasti požární ochrany',
          valid: {
            from: '2023-06-01',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Petr Čuřík',
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Poskytování služeb v oblasti bezpečnosti a ochrany zdraví při práci',
          valid: {
            from: '2023-06-01',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Petr Čuřík',
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: 'CZ8627000000000801811014',
          },
          {
            number: '800423773/0300',
          },
          {
            number: '801811022/2700',
          },
          {
            number: '801811065/2700',
          },
          {
            number: '801811006/2700',
          },
          {
            number: '2102476092/2700',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      country: 'CZ',
      name: 'ZaP s.r.o.',
      taxNumber: null,
      vatNumber: 'CZ05691737',
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Královéhradecký kraj',
          district: 'Náchod',
          ids: {
            internal: '17c1ca39-6824-4f6e-a0d8-8bd5cbf73b33',
            external: '7289944',
          },
          street: 'Rudé armády',
          number: {
            type: 'č.p.',
            part1: '191',
            part1Number: '191',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '191',
          },
          streetWithNumber: 'Rudé armády 191',
          city: 'Jaroměř',
          zip: '55102',
          full: 'Rudé armády 191, 55102 Jaroměř',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Rudé armády',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '191',
          },
          streetWithNumber: 'Rudé armády 191',
          city: 'Jaroměř',
          zip: '55102',
          full: 'Rudé armády 191, Josefov, 55102 Jaroměř',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '6820',
          name: 'Pronájem a správa vlastních nebo pronajatých nemovitostí',
          isPrimary: null,
        },
        {
          code: '74',
          name: 'Ostatní profesní, vědecké a technické činnosti',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSHK',
              name: 'Krajský soud v Hradci Králové',
              detail: null,
            },
            reference: 'C 40146',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '243',
              name: 'Územní pracoviště v Náchodě',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2017-01-10',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2017-01-10',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Výroba a hutní zpracování železa, drahých a neželezných kovů a jejich slitin',
            'Výroba, vývoj, projektování, zkoušky, instalace, údržba, opravy, modifikace a konstrukční změny letadel, motorů letadel, vrtulí, letadlových částí a zařízení a leteckých  pozemních zařízení',
            'Stavba a výroba plavidel',
            'Výroba strojů a zařízení',
            'Výroba neelektrických zařízení pro domácnost',
            'Výroba elektronických součástek, elektrických zařízení a výroba a opravy elektrických strojů, přístrojů a elektronických zařízení pracujících na malém napětí',
            'Výroba měřicích, zkušebních, navigačních, optických a fotografických přístrojů a zařízení',
            'Povrchové úpravy a svařování kovů a dalších materiálů',
            'Umělecko-řemeslné zpracování kovů',
            'Výroba kovových konstrukcí a kovodělných výrobků',
            'Výroba drážních hnacích vozidel a drážních vozidel na dráze tramvajové, trolejbusové a lanové a železničního parku',
            'Broušení technického a šperkového kamene',
            'Výroba brusiv a ostatních minerálních nekovových výrobků',
            'Výroba stavebních hmot, porcelánových, keramických a sádrových výrobků',
            'Výroba a zpracování skla',
            'Výroba plastových a pryžových výrobků',
            'Výroba hnojiv',
            'Výroba chemických látek a chemických směsí nebo předmětů a kosmetických přípravků',
            'Vydavatelské činnosti, polygrafická výroba, knihařské a kopírovací práce',
            'Zpracování dřeva, výroba dřevěných, korkových, proutěných a slaměných výrobků',
            'Výroba motorových a přípojných vozidel a karoserií',
            'Výroba dalších výrobků zpracovatelského průmyslu',
            'Služby v oblasti administrativní správy a služby organizačně hospodářské povahy',
            'Nakládání s reprodukčním materiálem lesních dřevin',
            'Výroba, opravy a údržba sportovních potřeb, her, hraček a dětských kočárků',
            'Zastavárenská činnost a maloobchod s použitým zbožím',
            'Příprava a vypracování technických návrhů, grafické a kresličské práce',
            'Výroba, rozmnožování, distribuce, prodej, pronájem zvukových a zvukově-obrazových záznamů a výroba nenahraných nosičů údajů a záznamů',
            'Úprava nerostů, dobývání rašeliny a bahna',
            'Provozování vodovodů a kanalizací a úprava a rozvod vody',
            'Velkoobchod a maloobchod',
            'Sklenářské práce, rámování a paspartování',
            'Přípravné a dokončovací stavební práce, specializované stavební činnosti',
            'Nakládání s odpady (vyjma nebezpečných)',
            'Výroba školních a kancelářských potřeb, kromě výrobků z papíru, výroba bižuterie, kartáčnického a konfekčního zboží, deštníků, upomínkových předmětů',
            'Výroba a opravy zdrojů ionizujícího záření',
            'Výroba zdravotnických prostředků',
            'Výroba a opravy čalounických výrobků',
            'Výroba jízdních kol, vozíků pro invalidy a jiných nemotorových dopravních prostředků',
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Provozování cestovní agentury a průvodcovská činnost v oblasti cestovního ruchu',
            'Překladatelská a tlumočnická činnost',
            'Fotografické služby',
            'Návrhářská, designérská, aranžérská činnost a modeling',
            'Reklamní činnost, marketing, mediální zastoupení',
            'Testování, měření, analýzy a kontroly',
            'Projektování elektrických zařízení',
            'Výzkum a vývoj v oblasti přírodních a technických věd nebo společenských věd',
            'Projektování pozemkových úprav',
            'Výroba a opravy obuvi, brašnářského a sedlářského zboží',
            'Pronájem a půjčování věcí movitých',
            'Činnost informačních a zpravodajských kanceláří',
            'Poskytování software, poradenství v oblasti informačních technologií, zpracování dat, hostingové a související činnosti a webové portály',
            'Ubytovací služby',
            'Skladování, balení zboží, manipulace s nákladem a technické činnosti v dopravě',
            'Zasilatelství a zastupování v celním řízení',
            'Potrubní a pozemní doprava (vyjma železniční a silniční motorové dopravy)',
            'Údržba motorových vozidel a jejich příslušenství',
            'Zprostředkování obchodu a služeb',
            'Mimoškolní výchova a vzdělávání, pořádání kurzů, školení, včetně lektorské činnosti',
            'Výroba vlákniny, papíru a lepenky a zboží z těchto materiálů',
            'Výroba textilií, textilních výrobků, oděvů a oděvních doplňků',
            'Výroba krmiv, krmných směsí, doplňkových látek a premixů',
            'Pěstitelské pálení',
            'Výroba, obchod a služby jinde nezařazené',
            'Výroba potravinářských a škrobárenských výrobků',
            'Poskytování služeb pro rodinu a domácnost',
            'Poskytování služeb osobního charakteru a pro osobní hygienu',
            'Chov zvířat a jejich výcvik (s výjimkou živočišné výroby)',
            'Opravy a údržba potřeb pro domácnost, předmětů kulturní povahy, výrobků jemné mechaniky, optických přístrojů a měřidel',
            'Poskytování technických služeb',
            'Praní pro domácnost, žehlení, opravy a údržba oděvů, bytového textilu a osobního zboží',
            'Činnost odborného lesního hospodáře a vyhotovování lesních hospodářských plánů a osnov',
            'Diagnostická, zkušební a poradenská činnost v ochraně rostlin a ošetřování rostlin, rostlinných produktů, objektů a půdy proti škodlivým organismům přípravky na ochranu rostlin nebo biocidními přípravky',
            'Poskytování služeb pro zemědělství, zahradnictví, rybníkářství, lesnictví a myslivost',
            'Provozování kulturních, kulturně-vzdělávacích a zábavních zařízení, pořádání kulturních produkcí, zábav, výstav, veletrhů, přehlídek, prodejních a obdobných akcí',
            'Provozování tělovýchovných a sportovních zařízení a organizování sportovní činnosti',
            'Výroba koksu, surového dehtu a jiných pevných paliv',
            'Nákup, prodej, správa a údržba nemovitostí',
          ],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '5388112369/0800',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      country: 'CZ',
      name: 'ZaP CZ s.r.o.',
      taxNumber: null,
      vatNumber: 'CZ28338804',
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Jihomoravský kraj',
          district: 'Hodonín',
          ids: {
            internal: '2b9e5240-33d9-479c-aa00-9584c5d9a3a1',
            external: '13383779',
          },
          street: 'Úzká',
          number: {
            type: 'č.p.',
            part1: '877',
            part1Number: '877',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '877',
          },
          streetWithNumber: 'Úzká 877',
          city: 'Čejkovice',
          zip: '69615',
          full: 'Úzká 877, 69615 Čejkovice',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Úzká',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '877',
          },
          streetWithNumber: 'Úzká 877',
          city: 'Čejkovice',
          zip: '69615',
          full: 'Úzká 877, 69615 Čejkovice',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '52',
          name: 'Skladování a vedlejší činnosti v dopravě',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSBR',
              name: 'Krajský soud v Brně',
              detail: null,
            },
            reference: 'C 62160',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '309',
              name: 'Územní pracoviště v Hodoníně',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2009-04-23',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2009-04-23',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Skladování, balení zboží, manipulace s nákladem a technické činnosti v dopravě',
            'Zprostředkování obchodu a služeb',
            'Velkoobchod a maloobchod',
          ],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '269574437/0300',
          },
          {
            number: '4262482001/5500',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      country: 'CZ',
      name: 'ZAP - PM s.r.o.',
      taxNumber: null,
      vatNumber: null,
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Jihočeský kraj',
          district: 'České Budějovice',
          ids: {
            internal: 'd549be8c-d294-4650-988c-4c2a2d510fac',
            external: '27060021',
          },
          street: 'Zavadilka',
          number: {
            type: 'č.p.',
            part1: '2575',
            part1Number: '2575',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '2575',
          },
          streetWithNumber: 'Zavadilka 2575',
          city: 'České Budějovice',
          zip: '37005',
          full: 'Zavadilka 2575, 37005 České Budějovice',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Zavadilka',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '2575',
          },
          streetWithNumber: 'Zavadilka 2575',
          city: 'České Budějovice',
          zip: '37005',
          full: 'Zavadilka 2575, České Budějovice 2, 37005 České Budějovice',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '4779',
          name: 'Maloobchod s použitým zbožím v prodejnách',
          isPrimary: null,
        },
        {
          code: '7729',
          name: 'Pronájem a leasing ostatních výrobků pro osobní potřebu a převážně pro domácnost',
          isPrimary: null,
        },
        {
          code: '90020',
          name: 'Podpůrné činnosti pro scénická umění',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSCB',
              name: 'Krajský soud v Českých Budějovicích',
              detail: null,
            },
            reference: 'C 21632',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '077',
              name: 'Územní pracoviště v Českých Budějovicích',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2013-03-20',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2013-03-20',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Zastavárenská činnost a maloobchod s použitým zbožím',
            'Pronájem a půjčování věcí movitých',
            'Provozování kulturních, kulturně-vzdělávacích a zábavních zařízení, pořádání kulturních produkcí, zábav, výstav, veletrhů, přehlídek, prodejních a obdobných akcí',
            'Zprostředkování obchodu a služeb',
            'Velkoobchod a maloobchod',
          ],
        },
      ],
      vat: {
        status: 'nonpayer',
        reliability: {
          reliable: null,
          unreliableFrom: null,
        },
        bankAccounts: [],
        history: [],
      },
    },
  },
  {
    data: {
      country: 'CZ',
      name: 'ZAP - PM s.r.o.',
      taxNumber: null,
      vatNumber: null,
      vatNumberSpecial: null,
      address: {
        data: {
          state: null,
          region: 'Jihočeský kraj',
          district: 'České Budějovice',
          ids: {
            internal: 'd549be8c-d294-4650-988c-4c2a2d510fac',
            external: '27060021',
          },
          street: 'Zavadilka',
          number: {
            type: 'č.p.',
            part1: '2575',
            part1Number: '2575',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '2575',
          },
          streetWithNumber: 'Zavadilka 2575',
          city: 'České Budějovice',
          zip: '37005',
          full: 'Zavadilka 2575, 37005 České Budějovice',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Zavadilka',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '2575',
          },
          streetWithNumber: 'Zavadilka 2575',
          city: 'České Budějovice',
          zip: '37005',
          full: 'Zavadilka 2575, České Budějovice 2, 37005 České Budějovice',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
        },
        {
          code: '4779',
          name: 'Maloobchod s použitým zbožím v prodejnách',
        },
        {
          code: '7729',
          name: 'Pronájem a leasing ostatních výrobků pro osobní potřebu a převážně pro domácnost',
        },
        {
          code: '90020',
          name: 'Podpůrné činnosti pro scénická umění',
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSCB',
              name: 'Krajský soud v Českých Budějovicích',
              detail: null,
            },
            reference: 'C 21632',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '077',
              name: 'Územní pracoviště v Českých Budějovicích',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2013-03-20',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2013-03-20',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Zastavárenská činnost a maloobchod s použitým zbožím',
            'Pronájem a půjčování věcí movitých',
            'Provozování kulturních, kulturně-vzdělávacích a zábavních zařízení, pořádání kulturních produkcí, zábav, výstav, veletrhů, přehlídek, prodejních a obdobných akcí',
            'Zprostředkování obchodu a služeb',
            'Velkoobchod a maloobchod',
          ],
        },
      ],
      vat: {
        status: 'nonpayer',
        reliability: {
          reliable: null,
          unreliableFrom: null,
        },
        bankAccounts: [],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: 'e7f52169-f3cf-4edf-8172-95ed8b3f7fb2',
      country: 'CZ',
      name: 'ZAP roll, s.r.o.',
      registrationNumber: '26251736',
      taxNumber: null,
      vatNumber: 'CZ26251736',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Zlínský kraj',
          district: 'Kroměříž',
          ids: {
            internal: '85fd759c-354a-48fa-a02b-3d3634f935c0',
            external: '27754286',
          },
          street: 'Za Zámeckou zahradou',
          number: {
            type: 'č.p.',
            part1: '1616',
            part1Number: '1616',
            part1Letter: null,
            part2: '20',
            part2Number: '20',
            part2Letter: null,
            full: '1616/20',
          },
          streetWithNumber: 'Za Zámeckou zahradou 1616/20',
          city: 'Kroměříž',
          zip: '76701',
          full: 'Za Zámeckou zahradou 1616/20, 76701 Kroměříž',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Za Zámeckou zahradou',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '1616/20',
          },
          streetWithNumber: 'Za Zámeckou zahradou 1616/20',
          city: 'Kroměříž',
          zip: '76701',
          full: 'Za Zámeckou zahradou 1616/20, 76701 Kroměříž',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '257',
          name: 'Výroba nožířských výrobků, nástrojů a železářských výrobků',
          isPrimary: null,
        },
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '471',
          name: 'Maloobchod v nespecializovaných prodejnách',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSBR',
              name: 'Krajský soud v Brně',
              detail: null,
            },
            reference: 'C 40079',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '320',
              name: 'Územní pracoviště v Kroměříži',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2001-06-25',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Zprostředkování obchodu',
          valid: {
            from: '2001-06-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2001-06-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Velkoobchod a maloobchod',
            'Zprostředkování obchodu a služeb',
          ],
        },
        {
          type: 'živnost volná',
          name: 'Velkoobchod',
          valid: {
            from: '2001-06-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkování služeb',
          valid: {
            from: '2001-06-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Zámečnictví, nástrojářství',
          valid: {
            from: '2008-09-01',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Jiří Perutík',
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '1483545359/0800',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '6b1e82a6-96f7-4fa9-8f34-c5081c828627',
      country: 'CZ',
      name: 'ZaP Tech, s.r.o.',
      registrationNumber: '29280371',
      taxNumber: null,
      vatNumber: null,
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Jihomoravský kraj',
          district: 'Brno-venkov',
          ids: {
            internal: 'f7c0b8cc-ec8b-42b7-946d-70a456bbd9cf',
            external: '27300161',
          },
          street: 'Přízřenická',
          number: {
            type: 'č.p.',
            part1: '1022',
            part1Number: '1022',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '1022',
          },
          streetWithNumber: 'Přízřenická 1022',
          city: 'Modřice',
          zip: '66442',
          full: 'Přízřenická 1022, 66442 Modřice',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Přízřenická',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '1022',
          },
          streetWithNumber: 'Přízřenická 1022',
          city: 'Modřice',
          zip: '66442',
          full: 'Přízřenická 1022, 66442 Modřice',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '016',
          name: 'Podpůrné činnosti pro zemědělství a posklizňové činnosti',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSBR',
              name: 'Krajský soud v Brně',
              detail: null,
            },
            reference: 'C 70590',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '293',
              name: 'Územní pracoviště Brno-venkov',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2011-05-30',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2011-05-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Výzkum a vývoj v oblasti přírodních a technických věd nebo společenských věd',
            'Praní pro domácnost, žehlení, opravy a údržba oděvů, bytového textilu a osobního zboží',
            'Provozování tělovýchovných a sportovních zařízení a organizování sportovní činnosti',
            'Poskytování služeb osobního charakteru a pro osobní hygienu',
            'Poskytování technických služeb',
            'Provozování kulturních, kulturně-vzdělávacích a zábavních zařízení, pořádání kulturních produkcí, zábav, výstav, veletrhů, přehlídek, prodejních a obdobných akcí',
            'Mimoškolní výchova a vzdělávání, pořádání kurzů, školení, včetně lektorské činnosti',
            'Fotografické služby',
            'Návrhářská, designérská, aranžérská činnost a modeling',
            'Reklamní činnost, marketing, mediální zastoupení',
            'Opravy a údržba potřeb pro domácnost, předmětů kulturní povahy, výrobků jemné mechaniky, optických přístrojů a měřidel',
            'Projektování pozemkových úprav',
            'Pronájem a půjčování věcí movitých',
            'Služby v oblasti administrativní správy a služby organizačně hospodářské povahy',
            'Provozování cestovní agentury a průvodcovská činnost v oblasti cestovního ruchu',
            'Překladatelská a tlumočnická činnost',
            'Testování, měření, analýzy a kontroly',
            'Projektování elektrických zařízení',
            'Příprava a vypracování technických návrhů, grafické a kresličské práce',
            'Chov zvířat a jejich výcvik (s výjimkou živočišné výroby)',
            'Potrubní a pozemní doprava (vyjma železniční a silniční motorové dopravy)',
            'Výroba dalších výrobků zpracovatelského průmyslu',
            'Výroba textilií, textilních výrobků, oděvů a oděvních doplňků',
            'Broušení technického a šperkového kamene',
            'Výroba krmiv, krmných směsí, doplňkových látek a premixů',
            'Výroba potravinářských a škrobárenských výrobků',
            'Výroba koksu, surového dehtu a jiných pevných paliv',
            'Úprava nerostů, dobývání rašeliny a bahna',
            'Výroba, rozmnožování, distribuce, prodej, pronájem zvukových a zvukově-obrazových záznamů a výroba nenahraných nosičů údajů a záznamů',
            'Výroba plastových a pryžových výrobků',
            'Vydavatelské činnosti, polygrafická výroba, knihařské a kopírovací práce',
            'Nakládání s reprodukčním materiálem lesních dřevin',
            'Výroba vlákniny, papíru a lepenky a zboží z těchto materiálů',
            'Zpracování dřeva, výroba dřevěných, korkových, proutěných a slaměných výrobků',
            'Poskytování služeb pro zemědělství, zahradnictví, rybníkářství, lesnictví a myslivost',
            'Výroba a opravy obuvi, brašnářského a sedlářského zboží',
            'Výroba, obchod a služby jinde nezařazené',
            'Poskytování služeb pro rodinu a domácnost',
            'Povrchové úpravy a svařování kovů a dalších materiálů',
            'Výroba, opravy a údržba sportovních potřeb, her, hraček a dětských kočárků',
            'Výroba a opravy čalounických výrobků',
            'Výroba, vývoj, projektování, zkoušky, instalace, údržba, opravy, modifikace a konstrukční změny letadel, motorů letadel, vrtulí, letadlových částí a zařízení a leteckých  pozemních zařízení',
            'Stavba a výroba plavidel',
            'Výroba motorových a přípojných vozidel a karoserií',
            'Výroba strojů a zařízení',
            'Výroba neelektrických zařízení pro domácnost',
            'Výroba elektronických součástek, elektrických zařízení a výroba a opravy elektrických strojů, přístrojů a elektronických zařízení pracujících na malém napětí',
            'Výroba měřicích, zkušebních, navigačních, optických a fotografických přístrojů a zařízení',
            'Činnost informačních a zpravodajských kanceláří',
            'Umělecko-řemeslné zpracování kovů',
            'Výroba kovových konstrukcí a kovodělných výrobků',
            'Výroba a hutní zpracování železa, drahých a neželezných kovů a jejich slitin',
            'Výroba brusiv a ostatních minerálních nekovových výrobků',
            'Výroba stavebních hmot, porcelánových, keramických a sádrových výrobků',
            'Výroba a zpracování skla',
            'Výroba hnojiv',
            'Pěstitelské pálení',
            'Výroba a opravy zdrojů ionizujícího záření',
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Poskytování software, poradenství v oblasti informačních technologií, zpracování dat, hostingové a související činnosti a webové portály',
            'Ubytovací služby',
            'Zasilatelství a zastupování v celním řízení',
            'Skladování, balení zboží, manipulace s nákladem a technické činnosti v dopravě',
            'Údržba motorových vozidel a jejich příslušenství',
            'Zastavárenská činnost a maloobchod s použitým zbožím',
            'Velkoobchod a maloobchod',
            'Zprostředkování obchodu a služeb',
            'Sklenářské práce, rámování a paspartování',
            'Přípravné a dokončovací stavební práce, specializované stavební činnosti',
            'Provozování vodovodů a kanalizací a úprava a rozvod vody',
            'Výroba školních a kancelářských potřeb, kromě výrobků z papíru, výroba bižuterie, kartáčnického a konfekčního zboží, deštníků, upomínkových předmětů',
            'Výroba jízdních kol, vozíků pro invalidy a jiných nemotorových dopravních prostředků',
            'Výroba drážních hnacích vozidel a drážních vozidel na dráze tramvajové, trolejbusové a lanové a železničního parku',
            'Nakládání s odpady (vyjma nebezpečných)',
            'Výroba zdravotnických prostředků',
            'Činnost odborného lesního hospodáře a vyhotovování lesních hospodářských plánů a osnov',
            'Výroba chemických látek a chemických směsí nebo předmětů a kosmetických přípravků',
            'Nákup, prodej, správa a údržba nemovitostí',
          ],
        },
      ],
      vat: {
        status: 'nonpayer',
        reliability: {
          reliable: null,
          unreliableFrom: null,
        },
        bankAccounts: [],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: 'a8ba1dd9-682c-4ed0-b72c-67a4a7199b2e',
      country: 'CZ',
      name: 'Zap Investing a.s.',
      registrationNumber: '24175871',
      taxNumber: null,
      vatNumber: null,
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Hlavní město Praha',
          district: 'území Hlavního města Prahy',
          ids: {
            internal: 'b78acd41-8413-4a53-83a6-3f075bf35bc6',
            external: '21942986',
          },
          street: 'Táborská',
          number: {
            type: 'č.p.',
            part1: '271',
            part1Number: '271',
            part1Letter: null,
            part2: '48',
            part2Number: '48',
            part2Letter: null,
            full: '271/48',
          },
          streetWithNumber: 'Táborská 271/48',
          city: 'Praha 4',
          zip: '14000',
          full: 'Táborská 271/48, 14000 Praha 4',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Táborská',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '271/48',
          },
          streetWithNumber: 'Táborská 271/48',
          city: 'Praha',
          zip: '14000',
          full: 'Táborská 271/48, Nusle, 14000 Praha 4',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '121',
        name: 'Akciová společnost',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '46900',
          name: 'Nespecializovaný velkoobchod',
          isPrimary: null,
        },
        {
          code: '620',
          name: 'Činnosti v oblasti informačních technologií',
          isPrimary: null,
        },
        {
          code: '68310',
          name: 'Zprostředkovatelské činnosti realitních agentur',
          isPrimary: null,
        },
        {
          code: '702',
          name: 'Poradenství v oblasti řízení',
          isPrimary: null,
        },
        {
          code: '772',
          name: 'Pronájem a leasing výrobků pro osobní potřebu a převážně pro domácnost',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'MSPH',
              name: 'Městský soud v Praze',
              detail: null,
            },
            reference: 'B 17617',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '004',
              name: 'Územní pracoviště pro Prahu 4',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2011-10-27',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2011-10-27',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Poskytování software, poradenství v oblasti informačních technologií, zpracování dat, hostingové a související činnosti a webové portály',
            'Pronájem a půjčování věcí movitých',
            'Zprostředkování obchodu a služeb',
            'Velkoobchod a maloobchod',
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Nákup, prodej, správa a údržba nemovitostí',
          ],
        },
      ],
      vat: {
        status: 'nonpayer',
        reliability: {
          reliable: null,
          unreliableFrom: null,
        },
        bankAccounts: [],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '75ab5b74-915a-41fe-8d2c-53e9c44479e2',
      country: 'CZ',
      name: 'Zaplo Finance s.r.o.',
      registrationNumber: '29413575',
      taxNumber: null,
      vatNumber: 'CZ29413575',
      vatNumberSpecial: null,
      address: null,
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Jungmannova',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '745/24',
          },
          streetWithNumber: 'Jungmannova 745/24',
          city: 'Praha',
          zip: '11000',
          full: 'Jungmannova 745/24, Nové Město, 11000 Praha 1',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '6492',
          name: 'Ostatní poskytování úvěrů',
          isPrimary: null,
        },
        {
          code: '70220',
          name: 'Ostatní poradenství v oblasti podnikání a řízení',
          isPrimary: null,
        },
        {
          code: '731',
          name: 'Reklamní činnosti',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'MSPH',
              name: 'Městský soud v Praze',
              detail: null,
            },
            reference: 'C 205150',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '001',
              name: 'Územní pracoviště pro Prahu 1',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '12503',
        name: 'Ostatní finanční zprostředkovatelé kromě pojišťovacích společností a penzijních fondů, pod zahraniční kontrolou',
      },
      dates: {
        created: '2013-01-25',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost vázaná',
          name: 'Poskytování spotřebitelského úvěru',
          valid: {
            from: '2013-01-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2013-01-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Reklamní činnost, marketing, mediální zastoupení',
            'Výroba, obchod a služby jinde nezařazené',
            'Zprostředkování obchodu a služeb',
          ],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '341040430/0300',
          },
          {
            number: '5438802/0800',
          },
          {
            number: 'CZ7608000000000005520582',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '141d6f55-ecd7-4eb9-9ac1-f174c12bb292',
      country: 'CZ',
      name: 'Zapletal-Kovo a.s.',
      registrationNumber: '26248026',
      taxNumber: null,
      vatNumber: 'CZ26248026',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Jihomoravský kraj',
          district: 'Brno-město',
          ids: {
            internal: '1c23967f-2f71-4fc4-ab7d-a52d5826c008',
            external: '19559682',
          },
          street: 'Elišky Přemyslovny',
          number: {
            type: 'č.p.',
            part1: '95',
            part1Number: '95',
            part1Letter: null,
            part2: '8',
            part2Number: '8',
            part2Letter: null,
            full: '95/8',
          },
          streetWithNumber: 'Elišky Přemyslovny 95/8',
          city: 'Brno',
          zip: '62500',
          full: 'Elišky Přemyslovny 95/8, 62500 Brno',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Elišky Přemyslovny',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '95/8',
          },
          streetWithNumber: 'Elišky Přemyslovny 95/8',
          city: 'Brno',
          zip: '62500',
          full: 'Elišky Přemyslovny 95/8, Starý Lískovec, 62500 Brno',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '121',
        name: 'Akciová společnost',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '25',
          name: 'Výroba kovových konstrukcí a kovodělných výrobků, kromě strojů a zařízení',
          isPrimary: null,
        },
        {
          code: '256',
          name: 'Povrchová úprava a zušlechťování kovů; obrábění',
          isPrimary: null,
        },
        {
          code: '25720',
          name: 'Výroba zámků a kování',
          isPrimary: null,
        },
        {
          code: '27120',
          name: 'Výroba elektrických rozvodných a kontrolních zařízení',
          isPrimary: null,
        },
        {
          code: '27900',
          name: 'Výroba ostatních elektrických zařízení',
          isPrimary: null,
        },
        {
          code: '331',
          name: 'Opravy kovodělných výrobků, strojů a zařízení',
          isPrimary: null,
        },
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '72',
          name: 'Výzkum a vývoj',
          isPrimary: null,
        },
        {
          code: '7219',
          name: 'Ostatní výzkum a vývoj v oblasti přírodních a technických věd',
          isPrimary: null,
        },
        {
          code: '72200',
          name: 'Výzkum a vývoj v oblasti společenských a humanitních věd',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSBR',
              name: 'Krajský soud v Brně',
              detail: null,
            },
            reference: 'B 3550',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '291',
              name: 'Územní pracoviště Brno IV',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2001-04-25',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Obchodní živnost - koupě zboží za účelem\njeho dalšího prodeje a prodej',
          valid: {
            from: '2001-04-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Zámečnictví, nástrojářství',
          valid: {
            from: '2001-04-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Richard Zapletal',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2001-04-25',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Richard Zapletal',
          activitySubjects: [
            'Výzkum a vývoj v oblasti přírodních a technických věd nebo společenských věd',
            'Výroba kovových konstrukcí a kovodělných výrobků',
            'Povrchové úpravy a svařování kovů a dalších materiálů',
            'Výroba elektronických součástek, elektrických zařízení a výroba a opravy elektrických strojů, přístrojů a elektronických zařízení pracujících na malém napětí',
            'Velkoobchod a maloobchod',
          ],
        },
        {
          type: 'živnost volná',
          name: 'Výroba elektrických strojů a přístrojů\na elektronických zařízení pracujících na\nmalém napětí a výroba elektrického vybavení',
          valid: {
            from: '2002-01-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba rozvaděčů nízkého napětí\na baterií, kabelů a vodičů',
          valid: {
            from: '2002-01-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Montáž, opravy, revize a zkoušky elektrických zařízení',
          valid: {
            from: '2002-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Richard Zapletal',
          activitySubjects: [],
        },
        {
          type: 'živnost řemeslná',
          name: 'Výroba, instalace, opravy elektrických strojů a přístrojů, elektronických a telekomunikačních zařízení',
          valid: {
            from: '2002-04-03',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Richard Zapletal',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výzkum a vývoj v oblasti přírodních a technických věd nebo společenských věd',
          valid: {
            from: '2006-05-17',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '264424149/0300',
          },
          {
            number: '290599524/0300',
          },
          {
            number: '273405660/0300',
          },
          {
            number: '273405732/0300',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: 'baabbfca-47a5-47b6-a3dc-89dd211e401e',
      country: 'CZ',
      name: 'Zapletálková s.r.o.',
      registrationNumber: '28826914',
      taxNumber: null,
      vatNumber: null,
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Královéhradecký kraj',
          district: 'Hradec Králové',
          ids: {
            internal: 'f400ede0-5cf3-4d81-a8de-7cc0a32374e9',
            external: '23870877',
          },
          street: 'Jeronýmova',
          number: {
            type: 'č.p.',
            part1: '750',
            part1Number: '750',
            part1Letter: null,
            part2: '1',
            part2Number: '1',
            part2Letter: null,
            full: '750/1',
          },
          streetWithNumber: 'Jeronýmova 750/1',
          city: 'Hradec Králové',
          zip: '50002',
          full: 'Jeronýmova 750/1, 50002 Hradec Králové',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Jeronýmova',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '750/1',
          },
          streetWithNumber: 'Jeronýmova 750/1',
          city: 'Hradec Králové',
          zip: '50002',
          full: 'Jeronýmova 750/1, 50002 Hradec Králové',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '7490',
          name: 'Ostatní profesní, vědecké a technické činnosti j. n.',
          isPrimary: null,
        },
        {
          code: '86220',
          name: 'Specializovaná ambulantní zdravotní péče',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSHK',
              name: 'Krajský soud v Hradci Králové',
              detail: null,
            },
            reference: 'C 29896',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '228',
              name: 'Územní pracoviště v Hradci Králové',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2011-12-19',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2011-12-19',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
          ],
        },
      ],
      vat: {
        status: 'nonpayer',
        reliability: {
          reliable: null,
          unreliableFrom: null,
        },
        bankAccounts: [],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '78b3ba12-cc04-4978-a15a-ff98bd65d7c5',
      country: 'CZ',
      name: 'Zapletal Josef',
      registrationNumber: '10552359',
      taxNumber: null,
      vatNumber: 'CZ5807140977',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Jihomoravský kraj',
          district: 'Brno-venkov',
          ids: {
            internal: 'f2d3eb6b-e328-4513-8db8-1f38755d118b',
            external: '23983043',
          },
          street: 'Za humny',
          number: {
            type: 'č.p.',
            part1: '288',
            part1Number: '288',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '288',
          },
          streetWithNumber: 'Za humny 288',
          city: 'Prštice',
          zip: '66446',
          full: 'Za humny 288, 66446 Prštice',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Za humny',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '288',
          },
          streetWithNumber: 'Za humny 288',
          city: 'Prštice',
          zip: '66446',
          full: 'Za humny 288, 66446 Prštice',
        },
      },
      legalForm: {
        type: 'physical',
        code: '107',
        name: 'Zemědělský podnikatel - fyzická osoba',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '011',
          name: 'Pěstování plodin jiných než trvalých',
          isPrimary: null,
        },
        {
          code: '016',
          name: 'Podpůrné činnosti pro zemědělství a posklizňové činnosti',
          isPrimary: null,
        },
        {
          code: '431',
          name: 'Demolice a příprava staveniště',
          isPrimary: null,
        },
        {
          code: '46189',
          name: 'Zprostředkování specializovaného velkoobchodu a velkoobchod v zastoupení s ostatními výrobky j. n.',
          isPrimary: null,
        },
        {
          code: '55',
          name: 'Ubytování',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '293',
              name: 'Územní pracoviště Brno-venkov',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '14100',
        name: 'Zaměstnavatelé',
      },
      dates: {
        created: '1990-05-01',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '1992-09-02',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Poskytování služeb pro zemědělství, zahradnictví, rybníkářství, lesnictví a myslivost',
            'Ubytovací služby',
            'Přípravné a dokončovací stavební práce, specializované stavební činnosti',
            'Zprostředkování obchodu a služeb',
            'Velkoobchod a maloobchod',
          ],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkovatelská činnost',
          valid: {
            from: '1992-09-02',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Poskytování služeb pro zemědělství a zahradnictví',
          valid: {
            from: '2008-02-04',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '935741621/0100',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: 'bbd83961-b4b8-4548-b84f-d889120d0390',
      country: 'CZ',
      name: 'ZAPLETENO, s.r.o.',
      registrationNumber: '14412616',
      taxNumber: null,
      vatNumber: 'CZ14412616',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Jihomoravský kraj',
          district: 'Brno-město',
          ids: {
            internal: 'bc46ba48-a219-4a55-942d-741cbf2b877a',
            external: '19196954',
          },
          street: 'třída Kpt. Jaroše',
          number: {
            type: 'č.p.',
            part1: '1922',
            part1Number: '1922',
            part1Letter: null,
            part2: '3',
            part2Number: '3',
            part2Letter: null,
            full: '1922/3',
          },
          streetWithNumber: 'třída Kpt. Jaroše 1922/3',
          city: 'Brno',
          zip: '60200',
          full: 'třída Kpt. Jaroše 1922/3, 60200 Brno',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'třída Kpt. Jaroše',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '1922/3',
          },
          streetWithNumber: 'třída Kpt. Jaroše 1922/3',
          city: 'Brno',
          zip: '60200',
          full: 'třída Kpt. Jaroše 1922/3, Černá Pole, 60200 Brno',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '14',
          name: 'Výroba oděvů',
          isPrimary: null,
        },
        {
          code: '47790',
          name: 'Maloobchod s použitým zbožím v prodejnách',
          isPrimary: null,
        },
        {
          code: '74300',
          name: 'Překladatelské a tlumočnické činnosti',
          isPrimary: null,
        },
        {
          code: '77290',
          name: 'Pronájem a leasing ostatních výrobků pro osobní potřebu a převážně pro domácnost',
          isPrimary: null,
        },
        {
          code: '855',
          name: 'Ostatní vzdělávání',
          isPrimary: null,
        },
        {
          code: '90020',
          name: 'Podpůrné činnosti pro scénická umění',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSBR',
              name: 'Krajský soud v Brně',
              detail: null,
            },
            reference: 'C 128207',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '288',
              name: 'Územní pracoviště Brno I',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2022-04-04',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2022-04-04',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Provozování kulturních, kulturně-vzdělávacích a zábavních zařízení, pořádání kulturních produkcí, zábav, výstav, veletrhů, přehlídek, prodejních a obdobných akcí',
            'Pronájem a půjčování věcí movitých',
            'Vydavatelské činnosti, polygrafická výroba, knihařské a kopírovací práce',
            'Reklamní činnost, marketing, mediální zastoupení',
            'Výroba, rozmnožování, distribuce, prodej, pronájem zvukových a zvukově-obrazových záznamů a výroba nenahraných nosičů údajů a záznamů',
            'Překladatelská a tlumočnická činnost',
            'Zprostředkování obchodu a služeb',
            'Mimoškolní výchova a vzdělávání, pořádání kurzů, školení, včetně lektorské činnosti',
            'Zastavárenská činnost a maloobchod s použitým zbožím',
            'Velkoobchod a maloobchod',
            'Výroba textilií, textilních výrobků, oděvů a oděvních doplňků',
          ],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '2502282561/2010',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '736dcb68-e397-4114-8f3c-87a9a669a04c',
      country: 'CZ',
      name: 'Zaplo Cargo s.r.o.',
      registrationNumber: '19300794',
      taxNumber: null,
      vatNumber: 'CZ19300794',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Moravskoslezský kraj',
          district: 'Ostrava-město',
          ids: {
            internal: 'a97c8ba8-c0da-494a-9025-fffdaa7570fd',
            external: '3167780',
          },
          street: 'Zemědělská',
          number: {
            type: 'č.p.',
            part1: '5382',
            part1Number: '5382',
            part1Letter: null,
            part2: '1',
            part2Number: '1',
            part2Letter: null,
            full: '5382/1',
          },
          streetWithNumber: 'Zemědělská 5382/1',
          city: 'Ostrava',
          zip: '72200',
          full: 'Zemědělská 5382/1, 72200 Ostrava',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Zemědělská',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '5382/1',
          },
          streetWithNumber: 'Zemědělská 5382/1',
          city: 'Ostrava',
          zip: '72200',
          full: 'Zemědělská 5382/1, Třebovice, 72200 Ostrava',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '45200',
          name: 'Opravy a údržba motorových vozidel, kromě motocyklů',
          isPrimary: null,
        },
        {
          code: '493',
          name: 'Ostatní pozemní osobní doprava',
          isPrimary: null,
        },
        {
          code: '49410',
          name: 'Silniční nákladní doprava',
          isPrimary: null,
        },
        {
          code: '77290',
          name: 'Pronájem a leasing ostatních výrobků pro osobní potřebu a převážně pro domácnost',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSOS',
              name: 'Krajský soud v Ostravě',
              detail: null,
            },
            reference: 'C 92505',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '390',
              name: 'Územní pracoviště Ostrava III',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2023-04-28',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost koncesovaná',
          name: 'Silniční motorová doprava - nákladní vnitrostátní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 3,5 tuny určenými k přepravě zvířat nebo věcí a nákladní mezinárodní provozovaná vozidly nebo jízdními soupravami o největší povolené hmotnosti nepřesahující 2,5 tuny určenými k přepravě zvířat nebo věcí, - osobní provozovaná vozidly určenými pro přepravu nejvýše 9 osob včetně řidiče',
          valid: {
            from: '2023-04-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2023-04-28',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Velkoobchod a maloobchod',
            'Údržba motorových vozidel a jejich příslušenství',
            'Pronájem a půjčování věcí movitých',
            'Zprostředkování obchodu a služeb',
          ],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '2002553310/2010',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: 'adf4d4cf-bb92-4c89-8092-b8090a3557ad',
      country: 'CZ',
      name: 'Zaplňto s.r.o.',
      registrationNumber: '09942327',
      taxNumber: null,
      vatNumber: null,
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Olomoucký kraj',
          district: 'Prostějov',
          ids: {
            internal: 'b85e2eb0-87ed-46e3-a9fe-fb81afb8e828',
            external: '78091942',
          },
          street: 'Wichterlova',
          number: {
            type: 'č.p.',
            part1: '394',
            part1Number: '394',
            part1Letter: null,
            part2: '37',
            part2Number: '37',
            part2Letter: null,
            full: '394/37',
          },
          streetWithNumber: 'Wichterlova 394/37',
          city: 'Prostějov',
          zip: '79604',
          full: 'Wichterlova 394/37, 79604 Prostějov',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Wichterlova',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '394/37',
          },
          streetWithNumber: 'Wichterlova 394/37',
          city: 'Prostějov',
          zip: '79604',
          full: 'Wichterlova 394/37, Krasice, 79604 Prostějov',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '73110',
          name: 'Činnosti reklamních agentur',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSBR',
              name: 'Krajský soud v Brně',
              detail: null,
            },
            reference: 'C 121392',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '325',
              name: 'Územní pracoviště v Prostějově',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2021-02-22',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2021-02-22',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Poskytování software, poradenství v oblasti informačních technologií, zpracování dat, hostingové a související činnosti a webové portály',
            'Reklamní činnost, marketing, mediální zastoupení',
          ],
        },
      ],
      vat: {
        status: 'nonpayer',
        reliability: {
          reliable: null,
          unreliableFrom: null,
        },
        bankAccounts: [],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '8d800779-3e63-4288-874d-6617335d77ed',
      country: 'CZ',
      name: 'ZAPL.EU s.r.o.',
      registrationNumber: '17232970',
      taxNumber: null,
      vatNumber: 'CZ17232970',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Moravskoslezský kraj',
          district: 'Frýdek-Místek',
          ids: {
            internal: '13f8aeae-6eda-4203-abbb-7145e92a41b5',
            external: '14212617',
          },
          street: 'Nýdek',
          number: {
            type: 'č.p.',
            part1: '12',
            part1Number: '12',
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '12',
          },
          streetWithNumber: 'Nýdek 12',
          city: 'Nýdek',
          zip: '73995',
          full: 'Nýdek 12, 73995 Nýdek',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Nýdek',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '12',
          },
          streetWithNumber: 'Nýdek 12',
          city: 'Nýdek',
          zip: '73995',
          full: 'č.p. 12, 73995 Nýdek',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '00',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          isPrimary: null,
        },
        {
          code: '25',
          name: 'Výroba kovových konstrukcí a kovodělných výrobků, kromě strojů a zařízení',
          isPrimary: null,
        },
        {
          code: '28',
          name: 'Výroba strojů a zařízení j. n.',
          isPrimary: null,
        },
        {
          code: '7112',
          name: 'Inženýrské činnosti a související technické poradenství',
          isPrimary: null,
        },
        {
          code: 'G',
          name: 'Velkoobchod a maloobchod; opravy a údržba motorových vozidel',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'KSOS',
              name: 'Krajský soud v Ostravě',
              detail: null,
            },
            reference: 'C 89610',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '364',
              name: 'Územní pracoviště v Třinci',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2022-06-13',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2022-06-13',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Výroba strojů a zařízení',
            'Zprostředkování obchodu a služeb',
            'Velkoobchod a maloobchod',
            'Příprava a vypracování technických návrhů, grafické a kresličské práce',
            'Výroba kovových konstrukcí a kovodělných výrobků',
          ],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '309845132/0300',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: 'c77af221-d1cb-4475-a5b6-cc27ceefa486',
      country: 'CZ',
      name: 'ZAPLETAL s.r.o.',
      registrationNumber: '62914308',
      taxNumber: null,
      vatNumber: 'CZ62914308',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Hlavní město Praha',
          district: 'území Hlavního města Prahy',
          ids: {
            internal: '9ffbe046-215d-42e3-a6bf-a8c04bb5d79e',
            external: '22777130',
          },
          street: 'Slavětínská',
          number: {
            type: 'č.p.',
            part1: '116',
            part1Number: '116',
            part1Letter: null,
            part2: '31',
            part2Number: '31',
            part2Letter: null,
            full: '116/31',
          },
          streetWithNumber: 'Slavětínská 116/31',
          city: 'Praha 9',
          zip: '19014',
          full: 'Slavětínská 116/31, 19014 Praha 9',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Slavětínská',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '116/31',
          },
          streetWithNumber: 'Slavětínská 116/31',
          city: 'Praha',
          zip: '19014',
          full: 'Slavětínská 116/31, Klánovice, 19014 Praha 9',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '46190',
          name: 'Zprostředkování nespecializovaného velkoobchodu a nespecializovaný velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '46750',
          name: 'Velkoobchod s chemickými výrobky',
          isPrimary: null,
        },
        {
          code: '471',
          name: 'Maloobchod v nespecializovaných prodejnách',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'MSPH',
              name: 'Městský soud v Praze',
              detail: null,
            },
            reference: 'C 35389',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '009',
              name: 'Územní pracoviště pro Prahu 9',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '1995-02-16',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Koupě zboží za účelem jeho dalšího prodeje a prodej\nmimo činností uvedených v příl. 1, 2, 3 zák. č. 455/91 Sb.',
          valid: {
            from: '1994-11-02',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkovatelská činnost v oblasti nákupu a prodeje zboží',
          valid: {
            from: '1994-11-02',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '1994-11-02',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Velkoobchod a maloobchod',
            'Pronájem a půjčování věcí movitých',
            'Zprostředkování obchodu a služeb',
            'Poradenská a konzultační činnost, zpracování odborných studií a posudků',
            'Přípravné a dokončovací stavební práce, specializované stavební činnosti',
            'Nákup, prodej, správa a údržba nemovitostí',
          ],
        },
        {
          type: 'živnost volná',
          name: 'Prodej chemických látek a chemických přípravků klasifikovaných jako hořlavé, zdraví škodlivé, žíravé, dráždivé, senzibilizující',
          valid: {
            from: '1999-06-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Výroba a prodej chemických látek a chemických přípravků klasifikovaných jako hořlavé, zdraví škodlivé, žíravé, dráždivé, senzibilizující',
          valid: {
            from: '1999-06-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost vázaná',
          name: 'Výroba nebezpečných chemických látek a nebezpečných chemických směsí a prodej  chemických látek a chemických směsí klasifikovaných jako vysoce toxické a toxické',
          valid: {
            from: '1999-06-30',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: 'Ing. Karel Zapletal',
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Výroba a dovoz chemických látek a chemických přípravků klasifikovaných jako výbušné, oxidující, extremně hořlavé, vysoce hořlavé, vysoce toxické, toxické, karcinogenní, mutagenní, toxické pro reprodukci, nebezpečné pro životní prostředí a pprodej ...',
          valid: {
            from: '1999-07-26',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '19-5524830227/0100',
          },
        ],
        history: [],
      },
    },
  },
  {
    data: {
      uuid: '65bb7642-b561-4c21-93ce-ebc4eaa42d01',
      country: 'CZ',
      name: 'ZAPLAVA GROUP s.r.o.',
      registrationNumber: '27538346',
      taxNumber: null,
      vatNumber: 'CZ27538346',
      vatNumberSpecial: null,
      address: {
        data: {
          country: 'CZ',
          state: null,
          region: 'Hlavní město Praha',
          district: 'území Hlavního města Prahy',
          ids: {
            internal: 'a79d4acd-6418-4138-9cbb-3eaf885eca1c',
            external: '21711402',
          },
          street: 'Krakovská',
          number: {
            type: 'č.p.',
            part1: '1346',
            part1Number: '1346',
            part1Letter: null,
            part2: '15',
            part2Number: '15',
            part2Letter: null,
            full: '1346/15',
          },
          streetWithNumber: 'Krakovská 1346/15',
          city: 'Praha 1',
          zip: '11000',
          full: 'Krakovská 1346/15, 11000 Praha 1',
        },
      },
      addressOfficial: {
        data: {
          country: 'CZ',
          street: 'Krakovská',
          number: {
            part1: null,
            part1Number: null,
            part1Letter: null,
            part2: null,
            part2Number: null,
            part2Letter: null,
            full: '1346/15',
          },
          streetWithNumber: 'Krakovská 1346/15',
          city: 'Praha',
          zip: '11000',
          full: 'Krakovská 1346/15, Nové Město, 11000 Praha 1',
        },
      },
      legalForm: {
        type: 'juridical',
        code: '112',
        name: 'Společnost s ručením omezeným',
      },
      legalFormSpecific: {
        code: null,
        name: null,
      },
      nace: [
        {
          code: '461',
          name: 'Zprostředkování velkoobchodu a velkoobchod v zastoupení',
          isPrimary: null,
        },
        {
          code: '68310',
          name: 'Zprostředkovatelské činnosti realitních agentur',
          isPrimary: null,
        },
      ],
      registrations: [
        {
          type: 'businessRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: 'MSPH',
              name: 'Městský soud v Praze',
              detail: null,
            },
            reference: 'C 261877',
          },
        },
        {
          type: 'vatRegister',
          data: {
            register: {
              code: null,
              name: null,
              detail: null,
            },
            registrator: {
              code: '001',
              name: 'Územní pracoviště pro Prahu 1',
              detail: null,
            },
            reference: null,
          },
        },
      ],
      esa2010: {
        code: '11002',
        name: 'Národní soukromé nefinanční podniky',
      },
      dates: {
        created: '2008-04-21',
        terminated: null,
      },
      tradeLicences: [
        {
          type: 'živnost volná',
          name: 'Výroba, obchod a služby neuvedené v přílohách 1 až 3 živnostenského zákona',
          valid: {
            from: '2008-04-21',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [
            'Zprostředkování obchodu a služeb',
            'Realitní činnost',
          ],
        },
        {
          type: 'živnost volná',
          name: 'Realitní činnost',
          valid: {
            from: '2008-04-21',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
        {
          type: 'živnost volná',
          name: 'Zprostředkování obchodu a služeb',
          valid: {
            from: '2008-04-21',
            fromText: null,
            to: null,
            toText: null,
          },
          interrupted: {
            from: null,
            to: null,
          },
          responsiblePerson: null,
          activitySubjects: [],
        },
      ],
      vat: {
        status: 'payer',
        reliability: {
          reliable: true,
          unreliableFrom: null,
        },
        bankAccounts: [
          {
            number: '8718731001/5500',
          },
        ],
        history: [],
      },
    },
  },
];

export default mockCompaniesList;
